/**
 * DataProvider
 *
 * @module DataProvider
 */
;(function DataProvider() {
    /**
     * Save all ajax markers
     * @type {Array}
     */
    var allAjaxMarkers = []

    /**
     * Save temporary ajax marker ids
     * @type {Object}
     */
    var tempAjaxMarkerId = {}

    /**
     * Gets the data for markers from the dom
     * @method markerFromDom
     * @param {object} dom A parent dom element of the markers
     * @returns {Array} Returning the marker data
     * @constructor
     */
    function markerFromDom(dom) {
        var markersDom = dom.querySelectorAll('[data-expert="marker"]')

        var markers = []
        Array.prototype.forEach.call(markersDom, function (markerDom, i) {
            var latitude = markerDom.getAttribute('data-expert-latitude')
            var longitude = markerDom.getAttribute('data-expert-longitude')
            var expertId = markerDom.getAttribute('data-expert-expertId')
            var label = markerDom.getAttribute('data-expert-label')
            var street = markerDom.getAttribute('data-expert-street')
            var zip = markerDom.getAttribute('data-expert-zip')
            var city = markerDom.getAttribute('data-expert-city')
            var mapInfoWindowLogo = markerDom.getAttribute('data-expert-map-infowindow-logo')

            // only if latitude and longitude are valid
            if (
                expertId.length > 0 &&
                !isNaN(expertId) &&
                latitude.length > 0 &&
                !isNaN(latitude) &&
                longitude.length > 0 &&
                !isNaN(longitude) &&
                label.length > 0 &&
                street.length > 0 &&
                zip.length > 0 &&
                city.length > 0 &&
                mapInfoWindowLogo.length > 0
            ) {
                markers.push({
                    expertId: expertId,
                    latitude: parseFloat(latitude),
                    longitude: parseFloat(longitude),
                    label: label,
                    street: street,
                    zip: zip,
                    city: city,
                    mapInfoWindowLogo: mapInfoWindowLogo,
                    content:
                        "<div style='float:left'><img class='juzo-google-map-markers' src='" +
                        mapInfoWindowLogo +
                        "'></div><div style='float:right; padding: 10px;'><b>" +
                        label +
                        '</b><br/>' +
                        street +
                        '<br/>' +
                        city +
                        '</div>',
                })
            }
            markerDom.parentNode.removeChild(markerDom)
        })

        return markers
    }

    /**
     * Provides markerdata
     * @method markerByAjax
     * @param {float} southWestLatitude
     * @param {float} southWestLongitude
     * @param {float} northEastLatitude
     * @param {float} northEastLongitude
     * @param userFilters
     * @constructor
     */
    function markerByAjax(
        southWestLatitude,
        southWestLongitude,
        northEastLatitude,
        northEastLongitude,
        userFilters,
        callback
    ) {
        var userCountryFilters = userFilters['countries']
        countryFilters = applyEditorFilters(
            userCountryFilters,
            'data-expert-editor-country-filters',
            'expertEditorCountryFilters'
        )
        var userDynamicFilters = userFilters['dynamicFilters']
        var dynamicFilters = applyEditorFilters(
            userDynamicFilters,
            'data-expert-editor-dynamic-filters',
            'expertEditorDynamicFilters'
        )

        $.ajax({
            url: '/expert-locator/search',
            data: {
                southWestLatitude: southWestLatitude,
                southWestLongitude: southWestLongitude,
                northEastLatitude: northEastLatitude,
                northEastLongitude: northEastLongitude,
                countryFilters: countryFilters.length > 0 ? countryFilters : null,
                dynamicFilters: dynamicFilters.length > 0 ? dynamicFilters : null,
                language: siteLanguage,
            },
            success: function (results) {
                var currentMarker = []
                var newMarkerStatus = false
                results = JSON.parse(results)

                // The 'cache' is emptied to return always all results
                // If only new markers are returned there is no way to tell which ones have been removed (country filter)
                tempAjaxMarkerId = {}

                Object.keys(results).forEach(function (key) {
                    var expertId = results[key]['expertId']
                    if (!(expertId in tempAjaxMarkerId)) {
                        tempAjaxMarkerId[expertId] = 1
                        newMarkerStatus = true
                        currentMarker.push(results[key])
                        allAjaxMarkers.push(currentMarker)
                    }
                })
                callback(currentMarker, newMarkerStatus)
            },
            error: function (xhr, status, error) {
                if (typeof error === 'function') {
                    error(error)
                } else if (typeof window.console != 'undefined' && typeof window.console.warn != 'undefined') {
                    console.warn(error)
                }
            },
        })
        return allAjaxMarkers
    }

    /**
     * Provides resultListdata
     * @method resultListByAjax
     * @param {float} southWestLatitude
     * @param {float} southWestLongitude
     * @param {float} northEastLatitude
     * @param {float} northEastLongitude
     * @param userFilters
     * @param callback
     */
    function resultListByAjax(
        southWestLatitude,
        southWestLongitude,
        northEastLatitude,
        northEastLongitude,
        userFilters,
        callback
    ) {
        var userCountryFilters = userFilters['countries']
        var countryFilters = applyEditorFilters(
            userCountryFilters,
            'data-expert-editor-country-filters',
            'expertEditorCountryFilters'
        )
        var userDynamicFilters = userFilters['dynamicFilters']
        var dynamicFilters = applyEditorFilters(
            userDynamicFilters,
            'data-expert-editor-dynamic-filters',
            'expertEditorDynamicFilters'
        )

        $.ajax({
            url: '/expert-locator/search',
            data: {
                southWestLatitude: southWestLatitude,
                southWestLongitude: southWestLongitude,
                northEastLatitude: northEastLatitude,
                northEastLongitude: northEastLongitude,
                countryFilters: countryFilters.length > 0 ? countryFilters : null,
                dynamicFilters: dynamicFilters.length > 0 ? dynamicFilters : null,
                language: siteLanguage,
            },
            success: function (response) {
                response = JSON.parse(response)
                callback(response)
            },
            error: function (xhr, status, error) {
                if (typeof error === 'function') {
                    error(error)
                } else if (typeof window.console != 'undefined' && typeof window.console.warn != 'undefined') {
                    console.warn(error)
                }
            },
        })
    }

    /**
     * Apply any use case filters if there are any
     * Otherwise return the default selection set by the editor
     *
     * @param userDynamicFilters
     * @returns {Array|*}
     */
    function applyEditorFilters(userFilters, dataIdentifier, dataValue) {
        if (userFilters.length > 0) {
            return userFilters
        }
        var editorFilters = getEditorFilters(dataIdentifier, dataValue)
        return editorFilters
    }

    /**
     * Extracts and processes the filter string to return an array of country filters selected by the editor
     * @returns array
     */
    function getEditorFilters(dataIdentifier, dataValue) {
        filtersString = $('[' + dataIdentifier + ']').data(dataValue)

        if (filtersString == undefined || filtersString.length < 1) {
            return []
        }
        filters = filtersString.split('|')

        filters = filters.filter(function (filter) {
            return filter !== ''
        })

        return filters.map(function (filter) {
            return filter.trim()
        })
    }

    if (typeof window.CreatonExperts === 'undefined') {
        window.CreatonExperts = {}
    }

    window.CreatonExperts.DataProvider = {
        markerByAjax: markerByAjax,
        markerFromDom: markerFromDom,
        resultListByAjax: resultListByAjax,
    }
})()
